export interface TableColumnVisibilityConfig {
  id?: string;
  isRowHeader?: boolean;
  /**
   * Controls contextual hiding without changing the user's persisted
   * preference. Contextually hidden columns remain available in the picker.
   */
  isHidden?: boolean;
  label?: string;
  pickerLabel?: string;
  toggleable?: boolean;
}

export interface ToggleableTableColumnConfig extends TableColumnVisibilityConfig {
  id: string;
  isRowHeader?: false;
  toggleable: true;
}

export const isToggleableColumn = (column: TableColumnVisibilityConfig): column is ToggleableTableColumnConfig => {
  return Boolean(column.toggleable === true && !column.isRowHeader && column.id);
};

export const getToggleableColumns = <T extends TableColumnVisibilityConfig>(
  columns: readonly T[],
): (T & ToggleableTableColumnConfig)[] =>
  columns.filter((column): column is T & ToggleableTableColumnConfig => isToggleableColumn(column));

export interface ColumnConfig<TSorting extends string> extends TableColumnVisibilityConfig {
  sortKey?: TSorting;
  align?: 'left' | 'center' | 'right';
}
